(() => {
  'use strict';

  const dialog = document.querySelector('[data-barros-quick-view]');
  const content = dialog?.querySelector('[data-barros-quick-view-content]');
  const closeButton = dialog?.querySelector('[data-barros-quick-view-close]');

  if (!dialog || !content) return;

  let activeTrigger = null;

  function openQuickView(trigger) {
    const template = trigger.nextElementSibling;

    if (
      !template ||
      !template.matches('template[data-barros-quick-view-template]')
    ) {
      return;
    }

    activeTrigger = trigger;

    const clonedContent = template.content.cloneNode(true);

    content.replaceChildren(clonedContent);

    document.body.classList.add('barros-quick-view-open');

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    closeButton?.focus();
  }

  function closeQuickView() {
    if (dialog.open && typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      cleanup();
    }
  }

  function cleanup() {
    document.body.classList.remove('barros-quick-view-open');

    content.replaceChildren();

    if (activeTrigger) {
      activeTrigger.focus();
      activeTrigger = null;
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(
      '[data-barros-quick-view-trigger]'
    );

    if (trigger) {
      event.preventDefault();
      openQuickView(trigger);
      return;
    }

    if (
      event.target.closest('[data-barros-quick-view-close]')
    ) {
      closeQuickView();
    }
  });

  dialog.addEventListener('click', (event) => {
    /*
      Click sull'area scura esterna al pannello.
    */
    if (event.target === dialog) {
      closeQuickView();
    }
  });

  dialog.addEventListener('close', cleanup);
})();